/**
 * Try to convert a string to a Date object. If the string is not a valid date, return null.
 * @param {Date | string | number | null | undefined} dateString The date string to convert into a Date object
 * @returns {Date} The datestring converted to a Date object
 */
export default function fixDate(dateString) {
	if (typeof dateString !== 'string' && typeof dateString !== 'number' && !(dateString instanceof Date) && dateString !== null && dateString !== undefined) {
		throw Error('input is not supported')
	}

	// if empty return null
	if (dateString === null || dateString === undefined || dateString === '') {
		return null
	}

	// if it is already a date, return that
	if (dateString instanceof Date) {
		return dateString
	}

	if (typeof dateString === 'number') {
		return new Date(dateString)
	}

	// input: "2020-01-01 00:00:00" or "2020-01-01 00:00"
	// find format
	// fix it by injecting a T "2020-01-01T00:00:00"
	// return a date
	// if it is a string, replace the space between date and time with a capital T (ISO date)
	const fixedDate = dateString.replace(' ', 'T')

	// return a Date Object
	return new Date(fixedDate)
}
